import { Component } from '@angular/core';
import { IconComponent } from '../../atoms/icon/icon.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-chart-void-card',
  imports: [IconComponent, TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div
        class="flex flex-col justify-center items-center border border-dashed border-neutral-6 px-4 py-10 rounded-lg min-h-28 bg-neutral-3 text-neutral-8"
      >
        <ui-icon icon="line-chart" class="text-[40px]" />
        <span>{{ t('CHARTS.VOID_MESSAGE_1') }}</span>
        <span>{{ t('CHARTS.VOID_MESSAGE_2') }}</span>
      </div>
    </ng-container>
  `,
})
export class ChartVoidCardComponent {}
